import { render } from "./Fitnes.vue?vue&type=template&id=2eb17b72&scoped=true"
import script from "./Fitnes.vue?vue&type=script&lang=js"
export * from "./Fitnes.vue?vue&type=script&lang=js"

import "./Fitnes.vue?vue&type=style&index=0&id=2eb17b72&lang=css"
import "./Fitnes.vue?vue&type=style&index=1&id=2eb17b72&scoped=true&lang=css"
import "./Fitnes.vue?vue&type=style&index=2&id=2eb17b72&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb17b72"]])

export default __exports__